import { gql, useMutation } from "@apollo/client";

const DELETE_IDEA_BOOK_ITEM = gql`
  mutation DeleteIdeaBookItem($itemId: ID!) {
    deleteIdeaBookItem(itemId: $itemId)
  }
`;

type DeleteIdeaBookItemData = {
  deleteIdeaBookItem: boolean;
};

type DeleteIdeaBookItemVars = {
  itemId: string;
};

export const useDeleteIdeaBookItem = () => {
  const [deleteIdeaBookItemMutation, { loading, error, data }] = useMutation<
    DeleteIdeaBookItemData,
    DeleteIdeaBookItemVars
  >(DELETE_IDEA_BOOK_ITEM);

  const deleteIdeaBookItem = async (args: DeleteIdeaBookItemVars) => {
    const result = await deleteIdeaBookItemMutation({ variables: args });
    return Boolean(result.data?.deleteIdeaBookItem);
  };

  return { deleteIdeaBookItem, loading, error, data };
};
